var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPdf(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "uuid-3f157e76-925b-4e12-bcaf-73fd372d5fe2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 27.26 31.91",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .uuid-83907922-7418-46fa-a44c-c52b484be5d1 {\n        fill: none;\n        stroke: #d4145a;\n        stroke-miterlimit: 10;\n        stroke-width: 2px;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "uuid-61603ff9-7af5-4d3a-9734-ee24d61f9d6b",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "uuid-83907922-7418-46fa-a44c-c52b484be5d1",
    d: "m4.2,23.85c1.01-5.94,1.05-11.35.29-15.88-.13-.84.88-1.48,1.47-.93,3.47,3.1,7.83,5.43,13.36,6.17.89.12,1.04,1.34.18,1.65-5.76,2.07-9.73,4.74-13.6,9.51-.62.74-1.85.37-1.7-.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-83907922-7418-46fa-a44c-c52b484be5d1",
    d: "m4.96,5.63l.02-2.79c.01-.9-.41-1.61-1.06-1.79h-.02c-.92-.25-2.01.61-2.41,1.89h0c-.31,1-.1,1.98.53,2.41l1.83,1.23c.45.3,1.11-.26,1.11-.95Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-83907922-7418-46fa-a44c-c52b484be5d1",
    d: "m5.14,25.82l.22,2.76c.08.89-.39,1.72-1.18,2.11h-.02c-1.12.55-2.48.04-2.97-1.12h0c-.38-.9-.13-1.94.59-2.57l2.05-1.78c.5-.44,1.27-.08,1.32.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-83907922-7418-46fa-a44c-c52b484be5d1",
    d: "m21.03,13.03l2.16-1.73c.69-.56,1.56-.67,2.21-.3h.02c.92.54,1.13,1.84.43,2.88h0c-.54.81-1.5,1.23-2.34,1.05l-2.39-.54c-.58-.13-.63-.93-.09-1.36Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPdf);
export default __webpack_public_path__ + "static/media/pdf.7c862ea9d9b8ba3ab7ca86084c432f3b.svg";
export { ForwardRef as ReactComponent };